import TreatmentPage from "./TreatmentPage";

export default function FungalInfection() {
  return (
    <TreatmentPage
      title="Fungal Infection"
      heroImage="/Treatment/fungal-infection-truptis-clinic.jpg"
      intro="Fungal infections (mycosis) are diseases caused by fungi (yeast or mold), frequently causing red, itchy, or scaly skin, nail discoloration, and, in severe cases, systemic issues. Common infections like athlete’s foot, ringworm."
      description="Internal Medicine and local antifungal application."
      howItWorks="It kills  fungi and  stop the growth."
      benefits={[
        "Early Diagnosis and treatment get  instant relief.",
      ]}
      beforeAfterImages={[
        "/Treatment/before-fungal-infection-truptis-clinic.jpeg",
        "/Treatment/after-fungal-infection-truptis-clinic.jpeg",
      ]}
      faqs={[
        { q: "Is it painful?", a: "Mild discomfort only, done under cooling gel." },
        { q: "How many sessions needed?", a: "Usually 4-6 sessions." },
      ]}
    />
  );
}
